import { CONTEXT_PATH } from './config_module';

export const PARAMS = {
  CLASSROOM: '$idClassroom',
  USER: '$idUser',
  GROUP: '$idGroup',
  BOOK: '$idBook',
  SCHOOL: '$idSchool',
  CUSTOMER: '$idCustomer',
  USERNAME: '$username',
  ASSET: '$uuidAsset',
  EMAIL: '$email',
  TOKEN: '$token',
  SECTION: '$idSection',
  UNIT: '$idUnit',
  TASK: '$idTask',
  MONTH: '$month',
  YEAR: '$year',
  LESSON: '$idLesson',
  PLATFORM: '$platform',
  ARCHITECTURE: '$architecture',
  PAGE: '$page',
  PAGE_SIZE: '$pageSize',
  TYPE: '$type',
  ITEMS: '$itemsPerPage',
  ACTIVITY: '$idActivity',
  LANGUAGE: '$language',
  DISCUSSION: '$idDiscussion',
  STATUS: '$status',
  ORDER: '$order',
  CLASSROOM_ID: '$classroomId',
  UNIT_ACTIVITY_ID: '$unitActivityId',
  FIELDS: '$fields',
  TIME_ZONE: '$timezone',
  GOOGLE_ACCESS_TOKEN: '$accessToken',
  GOOGLE_COURSE_ID: '$courseId',
  SKIN: '$skin'
};

// RABBIT --------------------------------------------------------------------------------------------------------------
export const NETWORK_ERROR = 'Network Error';
export const FAILED_TO_FETCH_ERROR = 'Failed to fetch';

// ROLES
export const ROLE = {
  INSTRUCTOR: 'INSTRUCTOR',
  STUDENT: 'STUDENT',
  COINSTRUCTOR: 'CO_INSTRUCTOR'
};
export const LTI_ROLES = {
  INSTRUCTOR: 'Instructor',
  STUDENT: 'Learner',
  CO_INSTRUCTOR: 'TeachingAssistant'
};

// USER
export const USER = {
  PROFILE: {
    defaultImage:
      'https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcTuzDDNhgMWlauST0DerGQz28HukBGo0SOxJNY0rJSXBK11us1rsRxUOV4'
  },
  LANGUAGES: [
    {
      name: 'Galego',
      image: 'gal_flag.png',
      value: 'gl'
    },
    {
      name: 'Español',
      image: 'spain_flag.png',
      value: 'es'
    },
    {
      name: 'Español (Argentina)',
      image: 'argentina_flag.png',
      value: 'es-ar'
    },
    {
      name: 'Español (Colombia)',
      image: 'colombia_flag.svg',
      value: 'es-co'
    },
    {
      name: 'Español (México)',
      image: 'mexico_flag.svg',
      value: 'es-mx'
    },
    {
      name: 'Español (Bolivia)',
      image: 'bolivia_flag.svg',
      value: 'es-bo'
    },
    {
      name: 'Español (Perú)',
      image: 'peru_flag.svg',
      value: 'es-pe'
    },
    {
      name: 'Español (Puerto Rico)',
      image: 'puertorico_flag.svg',
      value: 'es-pr'
    },
    {
      name: 'Español (Ecuador)',
      image: 'ecuador_flag.svg',
      value: 'es-ec'
    },
    {
      name: 'Portuguese (Brazil)',
      image: 'brazil_flag.svg',
      value: 'pt-br'
    },
    {
      name: 'English',
      image: 'britain_flag.png',
      value: 'en'
    },
    {
      name: 'Deutsch',
      image: 'deutschland_flag.png',
      value: 'de'
    }
  ]
};

// El acceso invitado solo ofrece los idiomas base: se omiten las variantes regionales del español.
const GUEST_LANGUAGE_VALUES = ['es', 'gl', 'en', 'pt-br', 'de'];
export const GUEST_LANGUAGES = GUEST_LANGUAGE_VALUES.map(value => USER.LANGUAGES.find(lang => lang.value === value));

// CLASSROOM STATE
export const CLASSROOM_STATE = {
  ACTIVE: {
    code: 1,
    state: 'active'
  },
  ARCHIVED: {
    code: 0,
    state: 'archived'
  }
};

// CAROUSEL
export const CAROUSEL = {
  FULL_SIZE: 4,
  PARTIAL_SIZE: 3,
  ITEM: {
    SIZE: 105
  }
};

// GROUPS
export const GROUPS = {
  EVERYONE: {
    id: 0,
    users: [],
    isGroup: true,
    isEveryone: true
  }
};

// ACTIVITY
export const ACTIVITY_TYPE = {
  BOOK: 'BOOK',
  LESSON: 'LESSON',
  UNIT: 'UNIT'
};

// PICTOGRAM CONFIGURATION
export const PICTOGRAM_CONFIG = {
  TEXT: 'text',
  IMAGE: 'image',
  TEXT_IMAGE: 'textImage'
};

// SUPPORTED LAYOUT SETTINGS menuRoutes
export const ROUTES_CONSTANTS = {
  ARCHIVE: 'ARCHIVE',
  LIBRARY: 'LIBRARY',
  HOME: 'HOME',
  CLASSROOM: 'CLASSROOM',
  CLASSROOM_STUDENTS: 'CLASSROOM_STUDENTS',
  CLASSROOM_LIBRARY: 'CLASSROOM_LIBRARY',
  MY_CONTENTS: 'MY_CONTENTS',
  CLASSROOM_WORKSPACE_LIBRARY: 'CLASSROOM_WORKSPACE_LIBRARY',
  CLASSROOM_WORKSPACE_LIBRARY_STUDENT: 'CLASSROOM_WORKSPACE_LIBRARY_STUDENT',
  CLASSROOM_ANALYTICS: 'CLASSROOM_ANALYTICS',
  ASSIGNMENTS: 'ASSIGNMENTS',
  ASSIGNMENTS_STUDENT: 'ASSIGNMENTS_STUDENT',
  GRADEBOOK: 'GRADEBOOK',
  DISCUSSIONS: 'DISCUSSIONS',
  STUDENT_ANNOTATIONS: 'STUDENT_ANNOTATIONS',
  STUDENT_ANALYTICS: 'STUDENT_ANALYTICS'
};

export const GOOGLE_MEET_PATH = 'https://meet.google.com/';
export const GOOGLE_VIDEOCALL_SCOPES = 'https://www.googleapis.com/auth/calendar.events';
export const GOOGLE_CLASSROOM_SCOPES_STUDENTS = 'https://www.googleapis.com/auth/classroom.coursework.students';
export const GOOGLE_CLASSROOM_SCOPES_COURSEWORK = 'https://www.googleapis.com/auth/classroom.courseworkmaterials';
export const GOOGLE_CLASSROOM_SCOPES_COURSES = 'https://www.googleapis.com/auth/classroom.courses';
export const GOOGLE_CLASSROOM_SCOPES_TOPICS = 'https://www.googleapis.com/auth/classroom.topics';
export const GOOGLE_USERINFO_SCOPES = 'https://www.googleapis.com/auth/userinfo.email';
export const GOOGLE_CLASSROOM_SCOPES = [
  GOOGLE_USERINFO_SCOPES,
  GOOGLE_CLASSROOM_SCOPES_STUDENTS,
  GOOGLE_CLASSROOM_SCOPES_COURSEWORK,
  GOOGLE_CLASSROOM_SCOPES_COURSES,
  GOOGLE_CLASSROOM_SCOPES_TOPICS
].join(' ');

// PARA SABER SI EN MODO OFFLINE TIENE QUE ESTAR ACTIVO EL MENÚ
// SI ESTÁ EN TRUE ESTARÁ DESACTIVADO DURANTE LA DESCONEXIÓN
export const ROUTES_CONSTANTS_CONFIG = {
  ARCHIVE: {
    offlineDisabled: true
  },
  LIBRARY: {
    offlineDisabled: true
  },
  HOME: {
    offlineDisabled: false
  },
  CLASSROOM: {
    offlineDisabled: false
  },
  CLASSROOM_STUDENTS: {
    offlineDisabled: true
  },
  CLASSROOM_LIBRARY: {
    offlineDisabled: true
  },
  CLASSROOM_WORKSPACE_LIBRARY: {
    offlineDisabled: true
  },
  CLASSROOM_WORKSPACE_LIBRARY_STUDENT: {
    offlineDisabled: true
  },
  CLASSROOM_ANALYTICS: {
    offlineDisabled: true
  },
  ASSIGNMENTS: {
    offlineDisabled: true
  },
  ASSIGNMENTS_STUDENT: {
    offlineDisabled: true
  },
  GRADEBOOK: {
    offlineDisabled: true
  },
  DISCUSSIONS: {
    offlineDisabled: true
  },
  STUDENT_ANNOTATIONS: {
    offlineDisabled: true
  },
  STUDENT_ANALYTICS: {
    offlineDisabled: false
  }
};

// SUPPORTED LAYOUT SETTINGS homeTabs
export const TABS_CONSTANTS = {
  ANALYTICS: 'ANALYTICS',
  ASSIGNMENTS: 'ASSIGNMENTS',
  ASSIGNMENTS_STUDENT: 'ASSIGNMENTS_STUDENT',
  MY_CLASSROOMS: 'MY_CLASSROOMS',
  MY_CONTENTS: 'MY_CONTENTS',
  DISCUSSIONS: 'DISCUSSIONS',
  GRADEBOOK: 'GRADEBOOK',
  CLASSROOM_LIBRARY: 'CLASSROOM_LIBRARY',
  CLASSROOM_WORKSPACE_LIBRARY: 'CLASSROOM_WORKSPACE_LIBRARY',
  CLASSROOM_WORKSPACE_LIBRARY_STUDENT: 'CLASSROOM_WORKSPACE_LIBRARY_STUDENT',
  CLASSROOM_ANALYTICS: 'CLASSROOM_ANALYTICS',
  STUDENT_ANALYTICS: 'STUDENT_ANALYTICS',
  CLASSROOM_STUDENTS: 'CLASSROOM_STUDENTS',
  MY_PROFILE: 'MY_PROFILE',
  STUDENT_ANNOTATIONS: 'STUDENT_ANNOTATIONS'
};

export const HOME_TABS = ['MY_CLASSROOMS', 'ASSIGNMENTS', 'CLASSROOM_LIBRARY'];

// SI ESTÁ EN TRUE ESTARÁ DESACTIVADO DURANTE LA DESCONEXIÓN
// "MY_CONTENTS", "ASSIGNMENTS", "CLASSROOM_STUDENTS", "DISCUSSIONS", "GRADEBOOK", "CLASSROOM_LIBRARY", "ANALYTICS"
export const TABS_CONSTANTS_CONFIG = {
  ANALYTICS: {
    offlineDisabled: true,
    studentDisabled: true
  },
  ASSIGNMENTS: {
    offlineDisabled: false,
    studentDisabled: false
  },
  ASSIGNMENTS_STUDENT: {
    offlineDisabled: false,
    studentDisabled: false
  },
  MY_CLASSROOMS: {
    offlineDisabled: false,
    studentDisabled: false
  },
  MY_CONTENTS: {
    offlineDisabled: false,
    studentDisabled: false
  },
  CLASSROOM_WORKSPACE_LIBRARY: {
    offlineDisabled: false,
    studentDisabled: true
  },
  CLASSROOM_WORKSPACE_LIBRARY_STUDENT: {
    offlineDisabled: false,
    studentDisabled: true
  },
  CLASSROOM_ANALYTICS: {
    offlineDisabled: false,
    studentDisabled: true
  },
  STUDENT_ANALYTICS: {
    offlineDisabled: false,
    studentDisabled: true
  },
  MY_PROFILE: {
    offlineDisabled: false,
    studentDisabled: false
  },
  CLASSROOM_STUDENTS: {
    offlineDisabled: true,
    studentDisabled: true
  },
  DISCUSSIONS: {
    offlineDisabled: true,
    studentDisabled: false
  },
  GRADEBOOK: {
    offlineDisabled: true,
    studentDisabled: true
  },
  CLASSROOM_LIBRARY: {
    offlineDisabled: true,
    studentDisabled: true
  },
  STUDENT_ANNOTATIONS: {
    offlineDisabled: true,
    studentDisabled: false,
    instructorDisabled: true
  }
};

export const TASK_TABS_CONSTANTS = {
  IN_PROGRESS: {
    label: 'tasks.current',
    key: 'IN_PROGRESS'
  },
  FINISHED: {
    label: 'tasks.finished',
    key: 'FINISHED'
  },
  FUTURE: {
    label: 'tasks.future',
    key: 'FUTURE'
  }
};

export const TASK_GROUP_MIN_PARTICIPANTS = 3;

export const INSTRUCTOR_TASK_TABS_CONSTANTS = TASK_TABS_CONSTANTS;
export const STUDENT_TASK_TABS_CONSTANTS = {
  IN_PROGRESS: TASK_TABS_CONSTANTS.IN_PROGRESS,
  FINISHED: TASK_TABS_CONSTANTS.FINISHED
};

export const DISCUSSIONS_PER_PAGE = 4;
export const POSTS_PER_PAGE = 4;
export const DISCUSSION_TABS_CONSTANTS = {
  IN_PROGRESS: {
    label: 'discussions.tabs.current',
    key: 'IN_PROGRESS'
  },
  FINISHED: {
    label: 'discussions.tabs.finished',
    key: 'FINISHED'
  },
  FUTURE: {
    label: 'discussions.tabs.future',
    key: 'FUTURE'
  }
};

export const PARTICIPANTS_TABS_CONSTANTS = {
  STUDENTS: {
    label: 'participants.tabs.students',
    key: 'STUDENTS'
  },
  TEACHERS: {
    label: 'participants.tabs.teachers',
    key: 'TEACHERS'
  }
};

export const ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS = {
  ARCHIVE: {
    translation: 'leftMenu.archive',
    icon: 'directory'
  },
  LIBRARY: {
    translation: 'leftMenu.library',
    icon: 'library'
  },
  HOME: {
    translation: 'home.title',
    icon: 'web-page-home'
  },
  CLASSROOM: {
    translation: 'leftMenu.workspace',
    icon: 'workspace'
  },
  CLASSROOM_STUDENTS: {
    translation: 'leftMenu.participants',
    icon: 'group-users-avatar'
  },
  CLASSROOM_LIBRARY: {
    translation: 'leftMenu.library',
    icon: 'library'
  },
  CLASSROOM_WORKSPACE_LIBRARY: {
    translation: 'leftMenu.workspaceLibrary',
    icon: 'library'
  },
  CLASSROOM_WORKSPACE_LIBRARY_STUDENT: {
    translation: 'leftMenu.workspaceLibraryStudent',
    icon: 'library'
  },
  ANALYTICS: {
    translation: 'leftMenu.analytics',
    icon: 'graph'
  },
  GRADEBOOK: {
    translation: 'leftMenu.gradebook',
    icon: 'gradebook'
  },
  DISCUSSIONS: {
    translation: 'leftMenu.discussions',
    icon: 'dialogue-balloon'
  },
  ASSIGNMENTS: {
    translation: 'leftMenu.assignments',
    icon: 'office-monthly-calendar'
  },
  ASSIGNMENTS_STUDENT: {
    translation: 'leftMenu.assignmentsStudent',
    icon: 'office-monthly-calendar'
  },
  MY_PROFILE: {
    translation: 'leftMenu.myProfile',
    icon: 'gradebook'
  },
  MY_CONTENTS: {
    translation: 'leftMenu.workspace',
    icon: 'workspace'
  },
  STUDENT_ANNOTATIONS: {
    translation: 'leftMenu.annotations',
    icon: 'writing-notepad'
  }
};

export const TABS_CONSTANTS_TRANSLATIONS = {
  ANALYTICS: 'home.analytics',
  HOME: 'home.title',
  CLASSROOM_ANALYTICS: 'leftMenu.analytics',
  MY_CLASSROOMS: 'home.myClassrooms',
  MY_CONTENTS: 'leftMenu.workspace',
  ASSIGNMENTS: 'leftMenu.assignments',
  CLASSROOM_STUDENTS: 'leftMenu.participants',
  DISCUSSIONS: 'leftMenu.discussions',
  GRADEBOOK: 'leftMenu.gradebook',
  CLASSROOM_LIBRARY: 'leftMenu.library',
  CLASSROOM_WORKSPACE_LIBRARY: 'leftMenu.workspaceLibrary',
  CLASSROOM_WORKSPACE_LIBRARY_STUDENT: 'leftMenu.workspaceLibraryStudent',
  STUDENT_ANALYTICS: 'leftMenu.analytics',
  MY_PROFILE: 'leftMenu.myProfile',
  STUDENT_ANNOTATIONS: 'leftMenu.annotations'
};

export const TABS_CONTSTANTS_ICONS = {
  MY_CLASSROOMS: 'reading-open-book',
  CLASSROOM_LIBRARY: 'library',
  ASSIGNMENTS: 'office-monthly-calendar'
};

export const ROUTES = {
  ROOT: `${CONTEXT_PATH}/`,
  HOME: `${CONTEXT_PATH}/home`,
  TASKS: `${CONTEXT_PATH}/tasks`,
  CLASSROOM: `${CONTEXT_PATH}/classroom`,
  CLASSROOM_BOOK: `${CONTEXT_PATH}/classroom/_classId_/book`,
  CLASSROOM_TASKS: `${CONTEXT_PATH}/classroom/_classId_/tasks`,
  GRADEBOOK: `${CONTEXT_PATH}/classroom/_classId_/gradebook`,
  STUDENT_ANNOTATIONS: `${CONTEXT_PATH}/classroom/_classId_/annotations`,
  LOGIN: `${CONTEXT_PATH}/login`,
  LOGINAUTH: `${CONTEXT_PATH}/login/auth`,
  RESET_PASSWORD: `${CONTEXT_PATH}/login/resetPassword`,
  FORGET_PASSWORD: `${CONTEXT_PATH}/login/forget`,
  ERROR: `${CONTEXT_PATH}/error`,
  ERROR_JAILED: `${CONTEXT_PATH}/error?jailed=true`,
  LOGIN_SENT: `${CONTEXT_PATH}/login/sent`,
  LOGIN_SURE: `${CONTEXT_PATH}/login/sure`,
  JOIN: `${CONTEXT_PATH}/join`,
  JOIN_GOOGLE: `${CONTEXT_PATH}/join/google/index`,
  JOIN_AZURE: `${CONTEXT_PATH}/join/azure/index`,
  JOIN_STUDENT: `${CONTEXT_PATH}/join/student`,
  JOIN_INSTRUCTOR: `${CONTEXT_PATH}/join/instructor`,
  PROFILE: `${CONTEXT_PATH}/profile`,
  REGISTER: `${CONTEXT_PATH}/register`,
  REGISTER_GOOGLE_CODE: `${CONTEXT_PATH}/join/google/code`,
  REGISTER_AZURE_CODE: `${CONTEXT_PATH}/join/azure/code`,
  BOOK: `${CONTEXT_PATH}/book`,
  LIBRARY: `${CONTEXT_PATH}/library`,
  ARCHIVE: `${CONTEXT_PATH}/archive`,
  SEARCH_RESULTS: `${CONTEXT_PATH}/search`,
  REDIRECT_CONTENT: `${CONTEXT_PATH}/launch`,
  COOKIES_DETAIL: `${CONTEXT_PATH}/cookies`,
  GUEST_LANDING: `${CONTEXT_PATH}/g`,
  GUEST_CATALOG: `${CONTEXT_PATH}/guest/catalog`,
  REGEXP: {
    CLASSROOM: /\/classroom\/[a-zA-Z0-9.-]*$/,
    CLASSROOM_BOOK: /\/classroom\/[a-zA-Z0-9.-]*\/book\/[a-zA-Z0-9.-]*$/,
    CLASSROOM_BOOK_LIBRARY: /\/classroom\/[a-zA-Z0-9.-]*\/book\/[a-zA-Z0-9.-]*\/library$/,
    CLASSROOM_STUDENTS: /\/classroom\/[a-zA-Z0-9.-]*\/students$/,
    CLASSROOM_ANALYTICS: /\/classroom\/[a-zA-Z0-9.-]*\/analytics$/,
    DISCUSSION_PAGE: /\/classroom\/[a-zA-Z0-9.-]*\/discussions\/[a-zA-Z0-9.-]*$/,
    HOME: /\/home$/,
    JOIN_GOOGLE: /\/join\/google\/index$/,
    LOGIN: /\/login$/,
    LOGIN_SENT: /\/login\/sent$/,
    LOGIN_SURE: /\/login\/sure$/,
    PROFILE: /\/profile$/,
    REGISTER: /\/register$/,
    LIBRARY: /\/library$/,
    CLASSROOM_LIBRARY: /\/classroom\/[a-zA-Z0-9.-]*\/library$/,
    ASSIGNMENTS: /\/classroom\/[a-zA-Z0-9.-]*\/tasks/,
    GRADEBOOK: /\/classroom\/[a-zA-Z0-9.-]*\/gradebook/,
    DISCUSSIONS: /\/classroom\/[a-zA-Z0-9.-]*\/discussions/,
    STUDENT_ANNOTATIONS: /\/classroom\/[a-zA-Z0-9.-]*\/annotations/,
    DISCUSSIONS_PAGE: /\/classroom\/[a-zA-Z0-9.-]*\/discussions\/[a-zA-Z0-9.-]*/,
    TASK: /(\/classroom\/)[a-zA-Z0-9.-]*(\/tasks)/,
    CLASSROOM_WORKSPACE_LIBRARY: /\/classroom\/[a-zA-Z0-9.-]*\/workspace/,
    CLASSROOM_WORKSPACE_LIBRARY_STUDENT: /\/classroom\/[a-zA-Z0-9.-]*\/workspace/,
    ARCHIVE: /\/archive$/,
    ERROR: /\/error$/,
    REDIRECT_CONTENT: /\/launch$/,
    SEARCH_RESULTS: /\/search$/,
    STUDENT_ANALYTICS: /\/classroom\/[a-zA-Z0-9.-]*\/student\/[a-zA-Z0-9.-]*$/,
    ANALYTICS: /\/classroom\/[a-zA-Z0-9.-]*\/analytics/
  }
};

export const DRAWER_CONTENTS = {
  CREATE_DISCUSSIONS_PANEL: 'CREATE_DISCUSSIONS_PANEL',
  CREATE_ASSIGNMENTS_FROM_BOOK: 'CREATE_ASSIGNMENTS_FROM_BOOK',
  DETAIL_ASSIGNMENTS: 'DETAIL_ASSIGNMENTS',
  STUDENTS_ASSIGNMENT: 'STUDENTS_ASSIGNMENT',
  ASSIGN_STUDENTS: 'ASSIGN_STUDENTS',
  LESSON_CREATE: 'LESSON_CREATE',
  UNIT_CREATE: 'UNIT_CREATE',
  EVALUATE_STUDENT_ASSIGNMENT: 'EVALUATE_STUDENT_ASSIGNMENT',
  CONTENT_ASSIGNMENTS: 'CONTENT_ASSIGNMENTS',
  STUDENT_TASK: 'STUDENT_TASK',
  INSTRUCTOR_TASK: 'INSTRUCTOR_TASK',
  CONTENT_CREATE: 'CONTENT_CREATE',
  SUBMIT_FREE_ASSIGNMENT: 'SUBMIT_FREE_ASSIGNMENT',
  ADD_NEW_USER: 'ADD_NEW_USER',
  ADD_USERS_TO_TASK: 'ADD_USERS_TO_TASK',
  CREATE_COOKIES_PANEL: 'CREATE_COOKIES_PANEL',
  CREATE_PROFILE_PANEL: 'CREATE_PROFILE_PANEL',
  VIEW_STUDENT_PROFILE_PANEL: 'VIEW_STUDENT_PROFILE_PANEL',
  SELECT_COURSE_GOOGLE: 'SELECT_COURSE_GOOGLE',
  RESOURCES_PREVIEW: 'RESOURCES_PREVIEW',
  SELECT_STUDENTS_FOR_ANALYTICS: 'SELECT_STUDENTS_FOR_ANALYTICS',
  NEAE_ADAPTATIONS_PANEL: 'NEAE_ADAPTATIONS_PANEL'
};

export const MESSAGES_SOCKET = {
  DISCUSSION_UPDATED: 'DISCUSSION_UPDATED',
  DISCUSSION_CREATED: 'DISCUSSION_CREATED',
  DISCUSSION_DELETED: 'DISCUSSION_DELETED',
  MESSAGE_UPDATED: 'MESSAGE_UPDATED',
  MESSAGE_CREATED: 'MESSAGE_CREATED',
  GROUP_UPDATE: 'group-update',
  STUDENT_UPDATE: 'student-update',
  ACTIVITY_UPDATE: 'activity-update',
  CLASSROOM_UPDATE: 'classroom-update',
  TASK_UPDATE: 'task-update',
  STUDENT_ENROLLMENT: 'student-enrollment',
  STUDENT_UNENROLLMENT: 'student-unenrollment',
  TEACHER_ENROLLMENT: 'instructor-enrollment',
  TEACHER_UNENROLLMENT: 'instructor-unenrollment',
  VIDEOCALL_STARTED: 'videocall-started',
  GOOGLE_COURSEWORK_FINISHED: 'coursework-finished'
};

export const API_LANGUAGE_PREFIX = 'api.';

export const SIZE = {
  SMALL: 768,
  MENU_HEADER: 154
};

// FILE TYPES
export const FILE_TYPES = {
  LNK: { mimeType: 'web/resource', extension: '' },
  ZIP: { mimeType: 'application/zip', extension: 'zip' }
};

export const EXTENSION_POLICY = {
  ALLOW: 'ALLOW',
  BLOCK: 'BLOCK'
};

export const WEB_TYPES = {
  HTML: { mimeType: 'text/html', extension: 'html' },
  HTM: { mimeType: 'text/html', extension: 'htm' }
};

export const CONNECTION = {
  TIMES_RECONECT: 3,
  MILS_TO_RECONNECT: 10000,
  MILS_TO_RECONNECT_RABBIT: 10000
};

export const RABBIT_CONNECTION = {
  WAIT: 'WAIT',
  OK: 'OK',
  KO: 'KO'
};

export const SERVICE_WORKERS = {
  OFFLINE: 'OfflineStatus'
};

export const EXTENSION = {
  ZIP: 'zip'
};

export const ELECTRON = {
  DATA_DIR: 'userData',
  IS_WINDOWS_APP:
    window.process && window.process.env.OS ? window.process.env.OS.toLowerCase().includes('windows') : '',
  INSTALL_DIR: window.process ? window.process.env.PWD : ''
};

export const DOWNLOAD = {
  COMPLETED: 100,
  EMPTY: 0,
  FINISHED: -1
};
export const BOOK_DOWNLOADING_STATUS = {
  EMPTY: 'EMPTY',
  DOWNLOADING: 'DOWNLOADING',
  UNZIPPING: 'UNZIPPING',
  PAUSE: 'PAUSE',
  CANCEL: 'CANCEL',
  COMPLETED: 'COMPLETED'
};

export const GRADE_VALUES = {
  VERY_POOR: 0,
  POOR: 1,
  ACCEPTABLE: 2,
  GOOD: 3,
  EXCELLENT: 4
};

export const TRANSLATE_TAG = {
  TITLE: '$title',
  CLASSROOM: '$classroom',
  DAYS: '$days',
  HOURS: '$hours',
  MINUTES: '$minutes'
};

export const CMI5 = {
  ACTIVITY_TYPE: {
    COURSE: 'https://w3id.org/xapi/smart/activity/book',
    UNIT: 'https://w3id.org/xapi/smart/activity/unit',
    LESSON: 'https://w3id.org/xapi/smart/activity/lesson',
    SCREEN: 'https://w3id.org/xapi/smart/activity/screen',
    VIDEO: 'https://w3id.org/xapi/smart/activity/video',
    AUDIO: 'https://w3id.org/xapi/smart/activity/audio',
    SINGLE_CHOICE: 'https://w3id.org/xapi/smart/activity/single-choice',
    MATRIXSINGLECHOICE: 'https://w3id.org/xapi/smart/activity/matrix-single-choice',
    MATRIXMULTIPLECHOICE: 'https://w3id.org/xapi/smart/activity/matrix-multiple-choice',
    SCORM: 'https://w3id.org/xapi/smart/activity/scorm',
    MULTIPLE_CHOICE: 'https://w3id.org/xapi/smart/activity/multiple-choice',
    INLINE_CHOICE: 'https://w3id.org/xapi/smart/activity/drop-down-choice',
    BINARYCHOICE: 'https://w3id.org/xapi/smart/activity/binary-choice',
    DISCUSSION: 'https://w3id.org/xapi/smart/activity/discussion',
    DRAGANDDROP: 'https://w3id.org/xapi/smart/activity/words-bank',
    ESSAY: 'https://w3id.org/xapi/smart/activity/essay',
    MATCHINGPAIR: 'https://w3id.org/xapi/smart/activity/matching-pairs',
    NOINTERACTIVE: 'https://w3id.org/xapi/smart/activity/no-interactive',
    TEXTENTRY: 'https://w3id.org/xapi/smart/activity/fill-in-the-gaps',
    LIKERT: 'https://w3id.org/xapi/smart/activity/likert',
    DRAW: 'https://w3id.org/xapi/smart/activity/draw',
    RESPONSE_IN_IMAGE: 'https://w3id.org/xapi/smart/activity/response-in-image',
    DEFAULT: 'https://w3id.org/xapi/smart/activity',
    AUDIO_RECORDING: 'https://w3id.org/xapi/smart/activity/audio-recording',
    UPLOAD_FILE: 'https://w3id.org/xapi/smart/activity/upload-file',
    RESOURCE: 'https://w3id.org/xapi/smart/resource',
    IMAGE_MULTIPLE_CHOICE: 'https://w3id.org/xapi/smart/activity/image-multiple-choice',
    DRAGGINGIMAGE: 'https://w3id.org/xapi/smart/activity/dragging-image',
    MATHFORMULAE: 'https://w3id.org/xapi/smart/activity/math-formulae',
    PASSWORD: 'https://w3id.org/xapi/smart/activity/password'
  },
  OPEN_ACTIVITY_TYPE: {
    ESSAY: 'https://w3id.org/xapi/smart/activity/essay',
    DRAW: 'https://w3id.org/xapi/smart/activity/draw',
    LIKERT: 'https://w3id.org/xapi/smart/activity/likert',
    AUDIO_RECORDING: 'https://w3id.org/xapi/smart/activity/audio-recording',
    UPLOAD_FILE: 'https://w3id.org/xapi/smart/activity/upload-file',
    MATHFORMULAE: 'https://w3id.org/xapi/smart/activity/math-formulae',
    PASSWORD: 'https://w3id.org/xapi/smart/activity/password'
  }
};

export const CMI5_INCLUDE_FIELDS = [
  'title',
  'description',
  'tags',
  'metadata',
  'imageUrl',
  'disabled',
  'url',
  'configuration',
  'fromCatalog',
  'importedExternalUnit',
  'format',
  'adaptation',
  'originalId'
];

export const LIBRARY = {
  MAX_PAGE_SIZE: 6,
  MAX_PAGE_SIZE_FILTERED: 18,
  TAGS: {
    TAGS: 'tags'
  },
  FILTER_TYPE: {
    PRIMARY_FILTER: 'PRIMARY_FILTER',
    SECONDARY_FILTER: 'SECONDARY_FILTER',
    TERTIARY_FILTER: 'TERTIARY_FILTER',
    OTHERS_FILTER: 'OTHERS_FILTER'
  },
  ACTIVITY_TYPE: {
    SINGLE_CHOICE: 'https://w3id.org/xapi/smart/activity/single-choice',
    MATRIXSINGLECHOICE: 'https://w3id.org/xapi/smart/activity/matrix-single-choice',
    MULTIPLE_CHOICE: 'https://w3id.org/xapi/smart/activity/multiple-choice',
    MATRIXMULTIPLECHOICE: 'https://w3id.org/xapi/smart/activity/matrix-multiple-choice',
    INLINE_CHOICE: 'https://w3id.org/xapi/smart/activity/drop-down-choice',
    BINARYCHOICE: 'https://w3id.org/xapi/smart/activity/binary-choice',
    DRAGANDDROP: 'https://w3id.org/xapi/smart/activity/words-bank',
    ESSAY: 'https://w3id.org/xapi/smart/activity/essay',
    MATCHINGPAIR: 'https://w3id.org/xapi/smart/activity/matching-pairs',
    TEXTENTRY: 'https://w3id.org/xapi/smart/activity/fill-in-the-gaps',
    LIKERT: 'https://w3id.org/xapi/smart/activity/likert',
    DRAW: 'https://w3id.org/xapi/smart/activity/draw',
    RESPONSE_IN_IMAGE: 'https://w3id.org/xapi/smart/activity/response-in-image',
    IMAGE_MULTIPLE_CHOICE: 'https://w3id.org/xapi/smart/activity/image-multiple-choice',
    DRAGGINGIMAGE: 'https://w3id.org/xapi/smart/activity/dragging-image',
    VIDEO: 'https://w3id.org/xapi/smart/activity/video',
    AUDIO: 'https://w3id.org/xapi/smart/activity/audio',
    NOINTERACTIVE: 'https://w3id.org/xapi/smart/activity/no-interactive',
    AUDIO_RECORDING: 'https://w3id.org/xapi/smart/activity/audio-recording',
    UPLOAD_FILE: 'https://w3id.org/xapi/smart/activity/upload-file',
    DISCUSSION: 'https://w3id.org/xapi/smart/activity/discussion',
    SCORM: 'https://w3id.org/xapi/smart/activity/scorm'
  },
  FILE_TYPES: {
    IMAGE: 'image',
    PICTOGRAM: 'pictogram',
    AUDIO: 'audio',
    PDF: 'application/pdf',
    VIDEO: 'video',
    OTHER: 'other'
  }
};

export const ERROR = {
  NOT_FOUND_GOOGLE: {
    code: 'error.user.notFoundGoogle',
    translationCode: ''
  },
  INVALID_SCHOOL_CODE: {
    code: 'error.backOffice.invalidSchool',
    translationCode: ''
  },
  INTERNAL_ERROR: {
    code: 'error.generic.internal',
    translationCode: 'error.generic500'
  },
  CLASSROOM_ARCHIVED: {
    code: 'error.classroom.archived',
    translationCode: 'error.classroom.archived'
  },
  NOT_FOUND_CLASSROOM: {
    code: 'error.classroom.notFound',
    translationCode: 'api.error.classroom.notFound'
  },
  CLASSROOM_FORBIDDEN: {
    code: 'error.classroom.unauthorizedUser',
    translationCode: 'api.error.classroom.unauthorizedUser'
  },
  USER_FORBIDDEN: {
    code: 'error.user.forbidden',
    translationCode: 'api.error.user.forbidden'
  },
  NOT_FOUND_ACTIVITY: {
    code: 'error.activity.notFound'
  },
  NOT_FOUND_BOOK: {
    code: 'error.book.notFound'
  },
  WRONG_SCHOOL_CODE: {
    code: 'error.wrong.schoolCode'
  },
  GUEST_CODE_NOT_FOUND: {
    code: 'error.guest.codeNotFound',
    translationCode: 'guest.error.codeNotFound'
  },
  GUEST_CODE_EXPIRED: {
    code: 'error.guest.codeExpired',
    translationCode: 'guest.error.codeExpired'
  },
  GUEST_SESSION_EXPIRED: {
    code: 'error.guest.sessionExpired',
    translationCode: 'guest.error.sessionExpired'
  }
};

export const LOCAL_UNIT_REPOSITORY = '/home/usuario/.contidoseva/lote2';

export const VERSION_COMPARE = {
  V1_LOWER_THAN_V2: -1,
  V1_EQUAL_TO_V2: 0,
  V1_GREATER_THAN_V2: 1,
  ERROR: false
};

export const CONTENT_SYNCHRONIZATION_STATUS = {
  EMPTY: 0,
  SYNCHRONIZING: 1,
  COMPLETED: 100
};

export const CDN_SYNCHRONIZATION_STATUS = {
  EMPTY: 0,
  SYNCHRONIZING: 1,
  COMPLETED: 100
};

export const EDITION_MODE = {
  EDITION: 'EDITION',
  CREATION: 'CREATION'
};

// APP NAME
// --------

export const PLATFORM_DEFAULT = 'smartED | smartClassroom';
export const APP_NAME = 'smart-ui';

export const BOOK_LAUNCH_MODES = {
  SMART: 'SMART',
  NONE: 'NONE'
};

export const DISCUSSION_MESSAGES_ORDER_OBJECT = {
  OLDER_FIRST: { name: 'discussions.common.order.olderFirst', id: 'asc' },
  NEWER_FIRST: { name: 'discussions.common.order.newerFirst', id: 'desc' }
};

export const PARTICIPANTS_ROLE_SELECTION = [
  { name: 'participants.select.instructor', value: ROLE.INSTRUCTOR },
  { name: 'participants.select.coinstructor', value: ROLE.COINSTRUCTOR }
];

// @see https://github.com/netexknowledge/smart-backoffice/blob/main/code/core/src/main/java/com/netexcompany/tdidacta/core/domain/asset/Asset.java#L30
export const ASSET_TYPES = {
  USER_AVATAR: 'USER_AVATAR',
  CLASSROOM_IMAGE: 'CLASSROOM_IMAGE',
  STUDENT_TASK: 'STUDENT_TASK',
  TEACHER_TASK: 'TEACHER_TASK',
  LESSON: 'LESSON'
};

// @see https://github.com/netexknowledge/smart-backoffice/blob/main/code/core/src/main/java/com/netexcompany/tdidacta/core/domain/customerConfiguration/CustomerConfiguration.java#L22
export const CLASSROOM_MODES = {
  EDUCATIONAL: 'EDUCATIONAL',
  CORPORATE: 'CORPORATE'
};

export const ANALYTICS_COOKIES = ['_ga', '_gat', '_gat_smart', '_gid', '__utma', '_clck', '_clsk'];

export const MEET_COOKIES = ['G_AUTHUSER_H', 'G_ENABLED_IDPS'];

export const SMART_STATUS_URL = 'https://status.smarted.cloud/';

export const GRADEBOOK_SCOPE = Object.freeze({
  ACTIVITIES: Symbol('ACTIVITIES_SCOPE'),
  UNIT_LESSONS: Symbol('UNIT_LESSONS_SCOPE'),
  TASKS: Symbol('TASKS_SCOPE')
});

export const PASS_THRESHOLD = 50;

export const ONE_HUNDRED = 100;
export const ZERO = 0;

export const MAX_LENGTH_VARIABLES = {
  NAME: 50,
  SURNAME: 50,
  EMAIL: 255,
  PASSWORD: 100,
  SCHOOL_CODE: 20,
  CLASS_CODE: 4,
  CLASS_NAME: 100,
  COMMENT: 255,
  DESCRIPTION: 255,
  UNIT_NAME: 100,
  LESSON_NAME: 50,
  TASK_NAME: 100,
  BOOK_NAME: 100,
  DISCUSSION_NAME: 100,
  GROUP_NAME: 50
};
